$(document).ready(function () {
  // Initial Hide
  $(".whatsapp-wrapper, .whatsapp-close-button, .size-chart-popup").hide();

  // WhatsApp Toggle
  $(".whatsapp-btn").click(function () {
    console.log("WhatsApp button clicked");
    $(".whatsapp-wrapper").show();
    $(this).hide();
    $(".whatsapp-close-button").show();
  });

  $(".whatsapp-close-button").click(function () {
    console.log("WhatsApp close clicked");
    $(".whatsapp-wrapper").hide();
    $(".whatsapp-btn").show();
    $(this).hide();
  });

  // Size Chart
  $(".size-chart-label span").click(() => {
    console.log("Size chart open clicked");
    $(".size-chart-popup").show();
  });
  $(".close-svg").click(() => {
    console.log("Size chart close clicked");
    $(".size-chart-popup").hide();
    $("#login_form_popup").hide();
  });
});

$(document).ready(function () {

  $('.sidebar-btn').on('click', function () {
    $('.facest-filters-section .m-sidebar--leftColumn .m-sidebar')
      .addClass('open');
  });

$(document).on('click', '.m-sidebar--close', function () {
    $('.facest-filters-section .m-sidebar--leftColumn .m-sidebar')
      .removeClass('open');
  });

});


function closePopUp() {
  const poweredBy = document.querySelector('.whatsapp__poweredBy');
  if (poweredBy) {
    poweredBy.style.display = 'none';
  }
}




(function () {
    const formSelector = '.m-newsletter-form__wrapper.m-newsletter-form__button-inline';
    const paramName = 'customer_posted';
    const storageKey = 'hideNewsletterFormOnce';

    function hideNewsletterForm() {
      const el = document.querySelector(formSelector);
      if (el) {
        el.style.display = 'none';
      }
    }

    function removeUrlParams() {
      const url = new URL(window.location.href);
      url.searchParams.delete(paramName);
      window.history.replaceState({}, document.title, url.pathname + url.search); // keeps hash only if needed
    }

    function hasCustomerPostedParam() {
      return window.location.search.includes(paramName);
    }

    // If param exists in URL after form submission
    if (hasCustomerPostedParam()) {
      hideNewsletterForm();
      localStorage.setItem(storageKey, 'true');
      // Slight delay before removing params to ensure Shopify success message is rendered
      setTimeout(removeUrlParams, 500);
    }

    // On refresh or next visit: hide form if previously hidden
    if (localStorage.getItem(storageKey) === 'true') {
      hideNewsletterForm();
    }
  })();


  document.addEventListener('DOMContentLoaded', function () {
    const notification = document.querySelector('.notification.show.newsletter');
    const formWrapper = document.querySelector('.m-newsletter-form__wrapper.m-newsletter-form__button-inline');

    if (notification && formWrapper) {
      formWrapper.style.display = 'none';
    }
  });


  window.onload = function () {
  const iframe = document.getElementById('hidden892499000000513053Frame');

  // Ensure iframe has loaded
   iframe.onload = function () {
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    // Select the first div inside the body
    const firstDiv = iframeDoc.body.querySelector('div');

    if (firstDiv) {
      firstDiv.style.background = 'none!important'; // or 'transparent'
    }
   }
};

function updateSizeChartImage() {
  const input = document.getElementById('product_id');
  const img = document.getElementById('popup_img_size_chart');

  if (!input || !img) return;

  const desktopUrl = input.getAttribute('data-sizechart-url');
  const mobileUrl = input.getAttribute('data-sizechart-url-mobile');

  if (window.innerWidth <= 768 && mobileUrl) {
    img.src = mobileUrl;
  } else if (desktopUrl) {
    img.src = desktopUrl;
  }
}

window.addEventListener('DOMContentLoaded', updateSizeChartImage);
window.addEventListener('resize', updateSizeChartImage);


window.addEventListener('load', function () {
    // Check if the popup has already been shown
    if (!localStorage.getItem('loginPopupShown')) {
      // Show popup after 3 seconds
      setTimeout(function () {
        document.getElementById('login_form_popup').style.display = 'block';
        // Mark the popup as shown
        localStorage.setItem('loginPopupShown', 'true');
      }, 3000);
    }
  });


  // =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
